import { render, staticRenderFns } from "./reminder-detail.vue?vue&type=template&id=409ab650&scoped=true&"
import script from "./reminder-detail.vue?vue&type=script&lang=js&"
export * from "./reminder-detail.vue?vue&type=script&lang=js&"
import style0 from "./reminder-detail.vue?vue&type=style&index=0&id=409ab650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409ab650",
  null
  
)

export default component.exports